var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsotipoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 171,
    viewBox: "0 0 137 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8623 68.2589C8.52992 68.2589 0.929688 75.8591 0.929688 85.1914C0.929688 94.5237 8.52992 102.124 17.8623 102.124H119.145C128.477 102.124 136.077 94.5237 136.077 85.1914C136.077 75.8591 128.477 68.2589 119.145 68.2589H17.8623Z",
    fill: "#332675"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7029 137.05C63.631 137.05 59.667 139.204 56.0153 142.84C52.3791 146.476 48.4619 148.395 43.468 148.395C38.4741 148.395 34.7599 146.647 30.796 142.684C26.8321 138.72 23.2429 137.05 18.2646 137.05C8.96351 137.05 1.44141 144.588 1.44141 153.873C1.44141 163.159 8.97911 170.696 18.2646 170.696C23.2897 170.696 27.0663 168.792 30.8585 165C34.6352 161.223 38.4429 159.335 43.468 159.335C48.4932 159.335 52.2074 161.114 56.2025 165.109C60.1976 169.104 63.7402 170.696 68.7029 170.696C78.004 170.696 85.5261 163.159 85.5261 153.873C85.5261 144.588 77.9884 137.05 68.7029 137.05Z",
    fill: "#36247A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7371 0.732178C8.37351 0.732178 0.773438 8.34786 0.773438 17.6958C0.773438 27.0437 8.38912 34.6594 17.7371 34.6594H69.2522C78.6158 34.6594 86.2159 27.0437 86.2159 17.6958C86.2159 8.34786 78.6002 0.732178 69.2522 0.732178H17.7371Z",
    fill: "#332675"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.116 34.4878C128.407 34.4878 135.939 26.9558 135.939 17.6646C135.939 8.37338 128.407 0.841339 119.116 0.841339C109.825 0.841339 102.293 8.37338 102.293 17.6646C102.293 26.9558 109.825 34.4878 119.116 34.4878Z",
    fill: "#332675"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.75 137.253C105.364 137.253 102.602 140.015 102.602 143.401V164.345C102.602 167.731 105.364 170.493 108.75 170.493H129.803C133.189 170.493 135.951 167.731 135.951 164.345V143.401C135.951 140.015 133.189 137.253 129.803 137.253H108.75Z",
    fill: "#332675"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipoDark);
export default __webpack_public_path__ + "static/media/isotipo_dark.3a2b59deae591160b32445c9a73ef636.svg";
export { ForwardRef as ReactComponent };